// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wpLW0","option":"styles_option__2srC-","active":"styles_active__1kWwR"};